import React from 'react';
import styled from 'styled-components';
import { COLORS, MQS } from '../../../app/common/constants/styles';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { addressServices } from './addressServices';

export interface IAddressService {
    id: string;
    name: string;
    link: string;
    logo: string;
    subtitle?: string;
    className?: string;
}

const UpdateInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 12px;
    border: 1px solid ${COLORS.rakutenRed};
    background: ${COLORS.rakutenPink};
    margin: 0 0 20px 0;

    @media (min-width: ${MQS.mq2Min}) {
        padding: 16px 12px;
        margin: 0 10px 26px 10px;
    }
`;

const ServicesBox = styled.div`
    display: grid;
    gap: 10px;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 1fr;

    @media (min-width: ${MQS.mq2Min}) {
        grid-template-rows: repeat(2, minmax(0, 1fr));
        grid-template-columns: repeat(4, minmax(0, 1fr));
    }
`;

const ServiceItem = styled.a`
    display: flex;
    flex: 1 1 0px;
    flex-direction: column;
    justify-content: center;
    padding: clamp(1rem, 10%, 2rem);

    min-width: 110px;

    border-radius: 4px;
    border: 1px solid #d1d5db;
    border-bottom-width: 2px;
    background-color: white;
    text-decoration: none;
    transition: opacity 0.2s;
`;

const ServiceSubtitle = styled.p`
    margin: 4px 0 0 0;
    text-align: center;
    font-size: 8px;
    line-height: 1.3;
    color: #374151;
    white-space: pre-wrap;

    @media (min-width: ${MQS.mq2Min}) {
        font-size: 11px;
    }
`;

const Title = styled.h3`
    font-size: 15px;
    color: ${COLORS.rakutenRed};
    padding: 0 0 0 28px;
    text-indent: -24px;
    margin: 0px;

    img {
        vertical-align: -1px;
        width: 20px;
        height: auto;
        margin: 0;
        padding: 0;
        border: 0;
        font-style: normal;
        font-weight: inherit;
        font-size: 100%;
    }
    span {
        margin-left: 2px;
    }
`;

const Description = styled.p`
    margin: 0;
    margin-top: 6px;
    padding: 0;
    display: flex;
    align-items: flex-start;
    font-size: 12px;
    line-height: 1.4;
    color: #000;

    @media (min-width: ${MQS.mq2Min}) {
        font-size: 13px;
        margin-top: 8px;
        line-height: 1.5;
    }
`;

const DescriptionIcon = styled.span`
    margin-right: 2px;
    font-size: 12px;

    @media (min-width: ${MQS.mq2Min}) {
        font-size: 13px;
    }
`;

const AddressUpdateInfo = () => {
    return (
        <>
            <UpdateInfo>
                <Title>
                    <img src="https://www.rakuten.co.jp/myrakuten/include/id/img/fintech/icn_service_info.png" />
                    <span>
                        {TranslationHelpers.getFormattedMessage('address.updated_info_box.title')}
                    </span>
                </Title>
                <Description>
                    <DescriptionIcon>&#x203B;</DescriptionIcon>
                    {TranslationHelpers.getFormattedMessage('address.updated_info_box.description')}
                </Description>
                <ServicesBox>
                    {addressServices.map((e) => {
                        return (
                            <ServiceItem
                                key={e.id}
                                href={e.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={e.className}
                            >
                                <img src={e.logo} alt={e.name} />
                                {e.subtitle && <ServiceSubtitle>{e.subtitle}</ServiceSubtitle>}
                            </ServiceItem>
                        );
                    })}
                </ServicesBox>
            </UpdateInfo>
        </>
    );
};

export default AddressUpdateInfo;
